'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _linksoftAlbatros = require('linksoft-albatros');

var _actions = require('../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _CartItem = require('./../components/CartItem');

var _CartItem2 = _interopRequireDefault(_CartItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

function mapStateToProps(state) {
    return {
        cart: state.cart
    };
}

var mapDispatchToProps = {
    update: _actions2.default.update,
    empty: _actions2.default.empty
};

var Cart = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
    (0, _inherits3.default)(Cart, _Component);

    function Cart(props) {
        (0, _classCallCheck3.default)(this, Cart);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Cart.__proto__ || (0, _getPrototypeOf2.default)(Cart)).call(this, props));

        _this.state = {
            disableMiniCart: false
        };
        return _this;
    }

    (0, _createClass3.default)(Cart, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var initialProps = this._root.parentNode.attributes['data-component-props'];
            if (initialProps && initialProps.value) {
                var initialState = JSON.parse(initialProps.value);
                this._root.parentNode.removeAttribute('data-component-props');
                if (initialState && initialState.cart) {
                    this.props.update(initialState.cart);
                    this.setState({ disableMiniCart: initialState.disableMiniCart });
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var cart = this.props.cart;
            var disableMiniCart = this.state.disableMiniCart;

            if (cart.items.length > 0) {
                setTimeout(function () {
                    $("#cartMenu").find(".scrollPane").mCustomScrollbar({
                        advanced: {
                            updateOnContentResize: true
                        },
                        scrollButtons: {
                            enable: false
                            // mouseWheelPixels: "200"
                        } });
                }, 0);
            }

            if (cart.items.length === 0) {
                return _react2.default.createElement(
                    'div',
                    { id: 'cartMenu', className: 'cartMenu emptyCart', ref: function ref(e) {
                            return _this2._root = e;
                        } },
                    _react2.default.createElement(
                        'a',
                        { href: '/Cart', title: Resx.Common.RedirectToCartDetailTitle },
                        _react2.default.createElement(
                            'span',
                            { className: 'cartRespons green' },
                            '+'
                        ),
                        _react2.default.createElement('i', { className: 'fa fa-shopping-basket' })
                    )
                );
            } else if (disableMiniCart) {
                return _react2.default.createElement(
                    'div',
                    { id: 'cartMenu', className: 'cartMenu', ref: function ref(e) {
                            return _this2._root = e;
                        } },
                    _react2.default.createElement(
                        'a',
                        { href: '/Cart', title: Resx.Common.RedirectToCartDetailTitle },
                        _react2.default.createElement(
                            'span',
                            { className: 'cartRespons' },
                            Resx.App.CartSummaryFormat.replace('{0}', cart.itemAmounts.length).replace('{1}', (0, _linksoftAlbatros.formatPrice)(cart.totalPrice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice))
                        ),
                        _react2.default.createElement('i', { className: 'fa fa-shopping-basket' })
                    )
                );
            } else {
                // render entire cart
                return _react2.default.createElement(
                    'div',
                    { id: 'cartMenu', className: 'dropdown cartMenu', ref: function ref(e) {
                            return _this2._root = e;
                        } },
                    _react2.default.createElement(
                        'a',
                        { href: '#', className: 'dropdown-toggle', 'data-toggle': 'dropdown' },
                        _react2.default.createElement(
                            'span',
                            { className: 'cartRespons' },
                            Resx.App.CartSummaryFormat.replace('{0}', cart.itemAmounts.length).replace('{1}', (0, _linksoftAlbatros.formatPrice)(cart.totalPrice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice))
                        ),
                        _react2.default.createElement('i', { className: 'fa fa-shopping-basket' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'dropdown-menu' },
                        _react2.default.createElement(
                            'div',
                            { className: 'w100 miniCartTable scrollPane' },
                            _react2.default.createElement(
                                'table',
                                { className: 'products-view-table' },
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    cart.items.slice(0, cart.miniCartMaxItems).map(function (item) {
                                        return _react2.default.createElement(_CartItem2.default, { key: item.id || item.productId, data: item, canChangeCart: cart.canChangeCart });
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'miniCartFooter text-right' },
                            _react2.default.createElement(
                                'h3',
                                { className: 'clearfix' },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'pull-left' },
                                    ' ',
                                    Resx.App.ItemsCount,
                                    ': ',
                                    (0, _linksoftAlbatros.format)(cart.itemAmounts.length, 'N0')
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'pull-right subtotal' },
                                    Resx.App.Total,
                                    ': ',
                                    (0, _linksoftAlbatros.formatPrice)(cart.totalPrice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                                )
                            ),
                            cart.canChangeCart ? _react2.default.createElement(
                                'button',
                                {
                                    id: 'emptyCart',
                                    className: 'btn btn-sm btn-danger pull-left',
                                    onClick: this.props.empty },
                                Resx.App.EmptyCart
                            ) : '',
                            _react2.default.createElement(
                                'a',
                                { href: '/Cart', className: 'btn btn-sm btn-green' },
                                Resx.App.ToTheOrder
                            )
                        )
                    )
                );
            }
        }
    }]);
    return Cart;
}(_react.Component)) || _class);


Cart.propTypes = {
    cart: _propTypes2.default.object.isRequired,

    update: _propTypes2.default.func.isRequired,
    empty: _propTypes2.default.func.isRequired,

    skipLoading: _propTypes2.default.bool
};

exports.default = Cart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/containers/cart.js
// module id = 910
// module chunks = 0